<template>
    <div>
        <app-tabela
            idTabela="tblDespesas"
            :itens="despesas"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes">
                <slot name="botoes"></slot>
            </template>
            <template slot="status" slot-scope="data">
                <app-status
                    :status="data.status.toUpperCase()"
                ></app-status>
            </template>
            <template slot="valorDespesa" slot-scope="data">{{
                data.valorDespesa | currency
            }}</template>
            <template slot="idMov" slot-scope="data">
                {{ data.idMov }}
                <status-id-mov :despesa="data"></status-id-mov>
                <btn-erro-comprometimento
                    :despesa="data"
                    :servicos="servicos"
                    :permiteAcesso="
                        permiteAcessoErroComprometimento
                    "
                ></btn-erro-comprometimento>
                <BtnExcluirComprometimento
                    :despesa="data"
                    :servicos="servicos"
                    @recarregarDespesas="$emit('recarregarDespesas')"
                    :permiteExcluir="permiteExcluirComprometimento"
                ></BtnExcluirComprometimento>
            </template>
            <template slot="acoes" slot-scope="data">
                <slot name="despesaAcoes" v-bind="data"></slot>
                <BtnAtualizarCentroCusto
                    :despesa="data"
                    :servicos="servicos"
                    :permiteAtualizarCentroCusto="permiteAtualizarCentroCusto"
                    @recarregarDespesas="$emit('recarregarDespesas')"
                ></BtnAtualizarCentroCusto>
                <btn-justificativa
                    :despesa="data"
                ></btn-justificativa>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import BtnAtualizarCentroCusto from './BtnAtualizarCentroCusto';
import BtnExcluirComprometimento from './BtnExcluirComprometimento';
import StatusIdMov from './StatusIdMov';
import BtnErroComprometimento from './BtnErroComprometimento';
import BtnJustificativa from './BtnJustificativa.vue';

export default {
    components: {
        BtnAtualizarCentroCusto,
        BtnExcluirComprometimento,
        StatusIdMov,
        BtnErroComprometimento,
        BtnJustificativa
    },

    props: {
        despesas: {
            type: Array,
            default: () => []
        },

        temPagamento: {
            type: Boolean,
            default: () => false
        },
    
        servicos: {
            type: Object,
            default: () => ({})
        },

        permiteAtualizarCentroCusto: {
           type: Boolean,
           default: false 
        },

        permiteExcluirComprometimento: {
           type: Boolean,
           default: false 
        }, 

        permiteAcessoErroComprometimento: {
            type: Boolean,
            default: false 
        }
    },
    
    data() {
        return {
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeUnidade',
                    label: 'Unidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeProjeto',
                    label: 'Projeto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeAcao',
                    label: 'Ação',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataExecucaoDespesa',
                    label: 'Data de Execução',
                    type: 'date',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'valorDespesa',
                    label: 'Valor da Despesa',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                },
                {
                    key: 'idMov',
                    label: 'Comprometimento',
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10,
        }
    },

    created() {
        if (this.temPagamento) {
            let pagamento = {
                    key: 'pagamento',
                    label: 'Registro de Pagamento'
            }
            this.campos.splice(8, 0, pagamento)
        }
    }
}
</script>